// Active-workspace API — moved from `src/features/workspace/api/{workspaces,
// workspaceInvitations}.ts` (now shims) at AW1, ARCFE-984, over the E5
// registry. Base path: /api/v2/ml-scribe/workspaces.
import { getScribeHttpClients } from '@heidi/api/client';
import {
  type ListWorkspaceInvitationsResponse,
  type ListWorkspacesResponse,
} from '../../contracts';

/** @domain workspace */
export async function listWorkspaces(): Promise<ListWorkspacesResponse> {
  const { data } =
    await getScribeHttpClients().scribeHttpV2.get<ListWorkspacesResponse>('/workspaces');
  return data;
}

/** @domain workspace */
export async function listWorkspaceInvitations(): Promise<ListWorkspaceInvitationsResponse> {
  const { data } =
    await getScribeHttpClients().scribeHttpV2.get<ListWorkspaceInvitationsResponse>(
      '/workspaces/invitations'
    );
  return data;
}
